import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard-moment',
  templateUrl: './dashboard-moment.component.html',
  styleUrls: ['./dashboard-moment.component.scss'],
})
export class DashboardMomentComponent {
  posts = [
    {
      user: {
        avatar: 'assets/images/user-profile.jpg',
        name: 'Teacher Bainun',
        title: 'Guru Kelas Purnama',
        website: 'Portfolio',
      },
      content:
        'My resumes have landed interviews at Microsoft, Amazon, EY, PwC, KPMG, and 100 more (Without any referrals) - Part 2',
      likes: 1685,
      // comments: 135,
      shares: 98,
      comments: [
        {
          user: 'Abu',
          text: 'Great post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '1h ago',
        },
        {
          user: 'Bob',
          text: 'Thanks for sharing.',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '2h ago',
        },
        {
          user: 'Aminah',
          text: 'Interesting thoughts.This is an excellent compilation of essential Git commands; having these at hand really simplifies the dKamillopment process!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '3h ago',
        },
        {
          user: 'Dahlia',
          text: 'Well written!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '4h ago',
        },
        {
          user: 'Kamil',
          text: 'I agree with you.',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '5h ago',
        },
        {
          user: 'Amri',
          text: 'Nice post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '6h ago',
        },
      ],      
      showComments: false,
      visibleCommentsCount: 3,
    },
    {
      user: {
        avatar: 'assets/images/user-profile.jpg',
        name: 'Sir Khai',
        title: 'Guru Kelas Mainun',
        website: 'Portfolio',
      },
      content: 'Just completed an amazing project using Angular and Firebase!',
      likes: 240,
      comments: [
        {
          user: 'Amri',
          text: 'Nice post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '6h ago',
        },
        {
          user: 'Abu',
          text: 'Great post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '1h ago',
        },
        {
          user: 'Bob',
          text: 'Thanks for sharing.',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '2h ago',
        },
        {
          user: 'Aminah',
          text: 'Interesting thoughts.',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '3h ago',
        },
        {
          user: 'Dahlia',
          text: 'Well written!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '4h ago',
        },
        {
          user: 'Amri',
          text: 'Nice post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '6h ago',
        },
        {
          user: 'Kamil',
          text: 'I agree with you.',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '5h ago',
        },
        {
          user: 'Amri',
          text: 'Nice post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '6h ago',
        },
      ],      
      showComments: false,
      visibleCommentsCount: 3,
      shares: 15,
    },
    {
      user: {
        avatar: 'assets/images/user-profile.jpg',
        name: 'Teacher Nurul',
        title: 'Guru Kelas Khairun',
        website: 'Portfolio',
      },
      content: 'Kelas batal!',
      likes: 240,
      comments: [
        {
          user: 'Abu',
          text: 'Great post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '1h ago',
        },
        {
          user: 'Bob',
          text: 'Thanks for sharing.',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '2h ago',
        },
        {
          user: 'Amri',
          text: 'Nice post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '6h ago',
        },
        {
          user: 'Aminah',
          text: 'Interesting thoughts.',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '3h ago',
        },
        {
          user: 'Dahlia',
          text: 'Well written!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '4h ago',
        },
        {
          user: 'Kamil',
          text: 'I agree with you.',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '5h ago',
        },
        {
          user: 'Amri',
          text: 'Nice post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '6h ago',
        },
      ],      
      showComments: false,
      visibleCommentsCount: 3,
      shares: 15,
    },
    {
      user: {
        avatar: 'assets/images/user-profile.jpg',
        name: 'Teacher Farhana',
        title: 'Guru Kelas Baihaqi',
        website: 'Portfolio',
      },
      content: 'Semua murid diminta hadir ke sekolah esok',
      likes: 240,
      comments: [
        {
          user: 'Abu',
          text: 'Great post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '1h ago',
        },
        {
          user: 'Bob',
          text: 'Thanks for sharing.',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '2h ago',
        },
        {
          user: 'Aminah',
          text: 'Interesting thoughts.',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '3h ago',
        },
        {
          user: 'Dahlia',
          text: 'Well written!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '4h ago',
        },
        {
          user: 'Amri',
          text: 'Nice post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '6h ago',
        },
        {
          user: 'Amri',
          text: 'Nice post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '6h ago',
        },
        {
          user: 'Amri',
          text: 'Nice post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '6h ago',
        },
        {
          user: 'Amri',
          text: 'Nice post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '6h ago',
        },
        {
          user: 'Amri',
          text: 'Nice post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '6h ago',
        },
        {
          user: 'Kamil',
          text: 'I agree with you.',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '5h ago',
        },
        {
          user: 'Amri',
          text: 'Nice post!',
          avatar: 'assets/images/user-profile.jpg',
          timestamp: '6h ago',
        },
      ],      
      showComments: false,
      visibleCommentsCount: 3,
      shares: 15,
    },
  ];
  isComingSoon = true;
  constructor() {}

  ngOnInit(): void {}

  toggleComments(post: any): void {
    post.showComments = !post.showComments;
  }
  
  loadMoreComments(post: any): void {
    post.visibleCommentsCount += 3; // Increase visible comments by 3
  }  
}
